import { all } from "redux-saga/effects";
import notification from "./notificationMiddleware";
import auth from "./authMiddleware";
import lessons from "./lessonsMiddlerware";

export default function* rootMiddleware() {
  yield all([notification(), auth(), lessons()]);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/index.js